import { render, staticRenderFns } from "./DailyOrder.vue?vue&type=template&id=64bbf278"
import script from "./DailyOrder.vue?vue&type=script&lang=js"
export * from "./DailyOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports